// AUTO-GENERATED from /app/memory/tas_flow_features.md — do not hand-edit.
// tier = minimum package that unlocks the feature (upper package includes lower).
export const TIER_ORDER = {"Starter": 1, "Plus": 2, "Pro": 3};
export const TAS_FLOW_MODULES = ["Platform & Genel", "Yapay Zekâ & Otomasyon", "İç Talepler & Ticket Yönetimi", "Travel API — Sorgulama & Rezervasyon (KPLUS)", "Uçuş Yönetimi", "Otel & Konaklama", "Araç Kiralama & Transfer", "Vize Yönetimi", "Etkinlik / MICE", "Seyahat Politikası & Onay", "TAS Flow Pulse (Canlı İstatistik)", "TAS Flow Intelligence (Veri Analizi)", "Raporlama & Dashboard", "Finans & Faturalama", "İnsan Kaynakları — Giriş/Çıkış (PDKS)", "CRM & Kurumsal Hesap", "Bildirim & İletişim", "Kullanıcı, Rol & Güvenlik", "Entegrasyonlar", "Arayüz, Mobil & Kullanılabilirlik", "Sistem Yönetimi & Altyapı", "Destek & SLA", "Görev, Takvim & İş Planı", "Belge & Sözleşme Yönetimi", "Müşteri Self-Servis Portalı", "Otomasyon Kuralları (No-Code)", "Kalite, Memnuniyet & Geri Bildirim", "Seyahatçi Güvenliği & Duty of Care", "Sürdürülebilirlik & Maliyet Optimizasyonu", "Raporlama — Ek Rapor Tipleri", "Travel API — Ek Sorgu & Ekranlar (KPLUS)", "Bildirim & İletişim — Ek", "İK — Ek Özellikler", "Yönetim & Ölçeklenme"];
export const TAS_FLOW_FEATURES = [
{
"name": "Tek merkezden operasyon paneli",
"module": "Platform & Genel",
"tier": "Starter"
},
{
"name": "Rol tabanlı çok kullanıcılı yapı",
"module": "Platform & Genel",
"tier": "Starter"
},
{
"name": "Kurumsal marka görünümü",
"module": "Platform & Genel",
"tier": "Plus"
},
{
"name": "Çoklu firma (multi-tenant) desteği",
"module": "Platform & Genel",
"tier": "Pro"
},
{
"name": "Türkçe/İngilizce dil desteği",
"module": "Platform & Genel",
"tier": "Plus"
},
{
"name": "Global arama",
"module": "Platform & Genel",
"tier": "Starter"
},
{
"name": "Favoriler & hızlı erişim",
"module": "Platform & Genel",
"tier": "Starter"
},
{
"name": "Kişiselleştirilebilir çalışma ekranı",
"module": "Platform & Genel",
"tier": "Plus"
},
{
"name": "Etkinlik/işlem denetim izi audit log",
"module": "Platform & Genel",
"tier": "Plus"
},
{
"name": "Karanlık/aydınlık tema",
"module": "Platform & Genel",
"tier": "Starter"
},
{
"name": "AI ile e-posta okuma",
"module": "Yapay Zekâ & Otomasyon",
"tier": "Plus"
},
{
"name": "Talep türü sınıflandırma",
"module": "Yapay Zekâ & Otomasyon",
"tier": "Plus"
},
{
"name": "Doğru departmana otomatik yönlendirme",
"module": "Yapay Zekâ & Otomasyon",
"tier": "Plus"
},
{
"name": "Aciliyet/öncelik tespiti",
"module": "Yapay Zekâ & Otomasyon",
"tier": "Plus"
},
{
"name": "E-postadan veri çıkarımı",
"module": "Yapay Zekâ & Otomasyon",
"tier": "Plus"
},
{
"name": "Otomatik ticket oluşturma",
"module": "Yapay Zekâ & Otomasyon",
"tier": "Plus"
},
{
"name": "E-posta thread eşleştirme",
"module": "Yapay Zekâ & Otomasyon",
"tier": "Plus"
},
{
"name": "Yanıt taslağı önerisi",
"module": "Yapay Zekâ & Otomasyon",
"tier": "Pro"
},
{
"name": "Dil algılama ve yönlendirme",
"module": "Yapay Zekâ & Otomasyon",
"tier": "Pro"
},
{
"name": "Rutin taleplerde otomatik aksiyon",
"module": "Yapay Zekâ & Otomasyon",
"tier": "Pro"
},
{
"name": "AI özet",
"module": "Yapay Zekâ & Otomasyon",
"tier": "Pro"
},
{
"name": "Anomali/uyum uyarısı",
"module": "Yapay Zekâ & Otomasyon",
"tier": "Pro"
},
{
"name": "İç talep açma ekranı",
"module": "İç Talepler & Ticket Yönetimi",
"tier": "Starter"
},
{
"name": "Talep kategorileri ve şablonlar",
"module": "İç Talepler & Ticket Yönetimi",
"tier": "Starter"
},
{
"name": "Ticket durum akışı",
"module": "İç Talepler & Ticket Yönetimi",
"tier": "Starter"
},
{
"name": "Departman/uzman atama",
"module": "İç Talepler & Ticket Yönetimi",
"tier": "Starter"
},
{
"name": "SLA süre takibi",
"module": "İç Talepler & Ticket Yönetimi",
"tier": "Plus"
},
{
"name": "SLA aşım uyarısı & eskalasyon",
"module": "İç Talepler & Ticket Yönetimi",
"tier": "Plus"
},
{
"name": "Talep içi mesajlaşma",
"module": "İç Talepler & Ticket Yönetimi",
"tier": "Starter"
},
{
"name": "Dosya/ek yükleme",
"module": "İç Talepler & Ticket Yönetimi",
"tier": "Starter"
},
{
"name": "Talep birleştirme/bölme",
"module": "İç Talepler & Ticket Yönetimi",
"tier": "Plus"
},
{
"name": "Talep etiketleme",
"module": "İç Talepler & Ticket Yönetimi",
"tier": "Plus"
},
{
"name": "Talep geçmişi",
"module": "İç Talepler & Ticket Yönetimi",
"tier": "Plus"
},
{
"name": "Tekrar açma/yeniden atama",
"module": "İç Talepler & Ticket Yönetimi",
"tier": "Plus"
},
{
"name": "Toplu işlem",
"module": "İç Talepler & Ticket Yönetimi",
"tier": "Plus"
},
{
"name": "Birleşik sorgu ekranı uçak+otel+araç",
"module": "Travel API — Sorgulama & Rezervasyon (KPLUS)",
"tier": "Plus"
},
{
"name": "Gerçek zamanlı uçuş sorgusu",
"module": "Travel API — Sorgulama & Rezervasyon (KPLUS)",
"tier": "Plus"
},
{
"name": "Otel uygunluk & fiyat sorgusu",
"module": "Travel API — Sorgulama & Rezervasyon (KPLUS)",
"tier": "Plus"
},
{
"name": "Araç kiralama sorgusu",
"module": "Travel API — Sorgulama & Rezervasyon (KPLUS)",
"tier": "Plus"
},
{
"name": "Çoklu tedarikçi karşılaştırma",
"module": "Travel API — Sorgulama & Rezervasyon (KPLUS)",
"tier": "Plus"
},
{
"name": "Çok bacaklı güzergâh arama",
"module": "Travel API — Sorgulama & Rezervasyon (KPLUS)",
"tier": "Plus"
},
{
"name": "Gelişmiş filtreler",
"module": "Travel API — Sorgulama & Rezervasyon (KPLUS)",
"tier": "Plus"
},
{
"name": "Birleşik teklif sepet",
"module": "Travel API — Sorgulama & Rezervasyon (KPLUS)",
"tier": "Plus"
},
{
"name": "Rezervasyon/opsiyon oluşturma",
"module": "Travel API — Sorgulama & Rezervasyon (KPLUS)",
"tier": "Pro"
},
{
"name": "Fiyat/kur güncelleme yansıtma",
"module": "Travel API — Sorgulama & Rezervasyon (KPLUS)",
"tier": "Pro"
},
{
"name": "Bilet/rezervasyon durum takibi PNR",
"module": "Travel API — Sorgulama & Rezervasyon (KPLUS)",
"tier": "Pro"
},
{
"name": "İptal/değişiklik işlemleri",
"module": "Travel API — Sorgulama & Rezervasyon (KPLUS)",
"tier": "Pro"
},
{
"name": "Yurt içi uçuş yönetimi",
"module": "Uçuş Yönetimi",
"tier": "Starter"
},
{
"name": "Yurt dışı uçuş yönetimi",
"module": "Uçuş Yönetimi",
"tier": "Plus"
},
{
"name": "Kurumsal tarife uygulama",
"module": "Uçuş Yönetimi",
"tier": "Plus"
},
{
"name": "Uçuş değişiklik yönetimi",
"module": "Uçuş Yönetimi",
"tier": "Plus"
},
{
"name": "Yolcu profili/tercih",
"module": "Uçuş Yönetimi",
"tier": "Plus"
},
{
"name": "Uçuş harcama raporu",
"module": "Uçuş Yönetimi",
"tier": "Plus"
},
{
"name": "Kısa dönem konaklama",
"module": "Otel & Konaklama",
"tier": "Starter"
},
{
"name": "Uzun dönem/proje konaklama",
"module": "Otel & Konaklama",
"tier": "Plus"
},
{
"name": "Grup konaklama yönetimi",
"module": "Otel & Konaklama",
"tier": "Plus"
},
{
"name": "Politika uyumlu otel seçimi",
"module": "Otel & Konaklama",
"tier": "Plus"
},
{
"name": "Konaklama harcama raporu",
"module": "Otel & Konaklama",
"tier": "Plus"
},
{
"name": "Araç kiralama yönetimi",
"module": "Araç Kiralama & Transfer",
"tier": "Plus"
},
{
"name": "Şoförlü araç tahsisi",
"module": "Araç Kiralama & Transfer",
"tier": "Plus"
},
{
"name": "Havalimanı transfer yönetimi",
"module": "Araç Kiralama & Transfer",
"tier": "Plus"
},
{
"name": "VIP transfer & protokol",
"module": "Araç Kiralama & Transfer",
"tier": "Pro"
},
{
"name": "Etkinlik/grup transferi",
"module": "Araç Kiralama & Transfer",
"tier": "Pro"
},
{
"name": "Vize talep ekranı",
"module": "Vize Yönetimi",
"tier": "Plus"
},
{
"name": "Evrak kontrol listesi",
"module": "Vize Yönetimi",
"tier": "Plus"
},
{
"name": "Randevu & başvuru takibi",
"module": "Vize Yönetimi",
"tier": "Plus"
},
{
"name": "Toplu grup vize süreci",
"module": "Vize Yönetimi",
"tier": "Pro"
},
{
"name": "Vize süreç raporu",
"module": "Vize Yönetimi",
"tier": "Plus"
},
{
"name": "Etkinlik proje yönetimi",
"module": "Etkinlik / MICE",
"tier": "Pro"
},
{
"name": "Katılımcı seyahat yönetimi",
"module": "Etkinlik / MICE",
"tier": "Pro"
},
{
"name": "Katılımcı kayıt yönetimi",
"module": "Etkinlik / MICE",
"tier": "Pro"
},
{
"name": "Etkinlik bütçe takibi",
"module": "Etkinlik / MICE",
"tier": "Pro"
},
{
"name": "Seyahat politikası tanımlama",
"module": "Seyahat Politikası & Onay",
"tier": "Plus"
},
{
"name": "Bütçe/limit kuralları",
"module": "Seyahat Politikası & Onay",
"tier": "Plus"
},
{
"name": "Politika dışı uyarı",
"module": "Seyahat Politikası & Onay",
"tier": "Plus"
},
{
"name": "Çok kademeli onay akışı",
"module": "Seyahat Politikası & Onay",
"tier": "Plus"
},
{
"name": "Mobil onay",
"module": "Seyahat Politikası & Onay",
"tier": "Pro"
},
{
"name": "Tercih edilen tedarikçi kuralı",
"module": "Seyahat Politikası & Onay",
"tier": "Plus"
},
{
"name": "Canlı istatistik gösterge ekranı",
"module": "TAS Flow Pulse (Canlı İstatistik)",
"tier": "Plus"
},
{
"name": "Anlık talep/işlem sayaçları",
"module": "TAS Flow Pulse (Canlı İstatistik)",
"tier": "Plus"
},
{
"name": "Departman yoğunluk göstergesi",
"module": "TAS Flow Pulse (Canlı İstatistik)",
"tier": "Plus"
},
{
"name": "SLA performans göstergesi",
"module": "TAS Flow Pulse (Canlı İstatistik)",
"tier": "Plus"
},
{
"name": "Günlük/haftalık trend grafikleri",
"module": "TAS Flow Pulse (Canlı İstatistik)",
"tier": "Plus"
},
{
"name": "Canlı bildirim akışı",
"module": "TAS Flow Pulse (Canlı İstatistik)",
"tier": "Plus"
},
{
"name": "Hedef & KPI kartları",
"module": "TAS Flow Pulse (Canlı İstatistik)",
"tier": "Pro"
},
{
"name": "Büyük ekran TV modu",
"module": "TAS Flow Pulse (Canlı İstatistik)",
"tier": "Pro"
},
{
"name": "Şirket verisi analiz alanı",
"module": "TAS Flow Intelligence (Veri Analizi)",
"tier": "Plus"
},
{
"name": "Departman/proje bazlı analiz",
"module": "TAS Flow Intelligence (Veri Analizi)",
"tier": "Plus"
},
{
"name": "Tasarruf & verimlilik analizi",
"module": "TAS Flow Intelligence (Veri Analizi)",
"tier": "Pro"
},
{
"name": "Zamanlanmış rapor e-postası",
"module": "TAS Flow Intelligence (Veri Analizi)",
"tier": "Plus"
},
{
"name": "Periyodik otomatik gönderim",
"module": "TAS Flow Intelligence (Veri Analizi)",
"tier": "Plus"
},
{
"name": "Alıcı listesi yönetimi",
"module": "TAS Flow Intelligence (Veri Analizi)",
"tier": "Plus"
},
{
"name": "Özelleştirilebilir rapor şablonları",
"module": "TAS Flow Intelligence (Veri Analizi)",
"tier": "Pro"
},
{
"name": "Dönemsel karşılaştırma",
"module": "TAS Flow Intelligence (Veri Analizi)",
"tier": "Pro"
},
{
"name": "Tahmin/öngörü analizi",
"module": "TAS Flow Intelligence (Veri Analizi)",
"tier": "Pro"
},
{
"name": "Rapor dışa aktarma Excel/PDF",
"module": "TAS Flow Intelligence (Veri Analizi)",
"tier": "Plus"
},
{
"name": "Yönetim dashboard'u",
"module": "Raporlama & Dashboard",
"tier": "Plus"
},
{
"name": "Harcama raporları",
"module": "Raporlama & Dashboard",
"tier": "Plus"
},
{
"name": "Talep hacmi raporu",
"module": "Raporlama & Dashboard",
"tier": "Plus"
},
{
"name": "SLA/performans raporu",
"module": "Raporlama & Dashboard",
"tier": "Plus"
},
{
"name": "Özelleştirilebilir grafikler",
"module": "Raporlama & Dashboard",
"tier": "Pro"
},
{
"name": "Zamanlanmış rapor gönderimi",
"module": "Raporlama & Dashboard",
"tier": "Plus"
},
{
"name": "Excel/PDF dışa aktarım",
"module": "Raporlama & Dashboard",
"tier": "Starter"
},
{
"name": "Fatura & işlem takibi",
"module": "Finans & Faturalama",
"tier": "Plus"
},
{
"name": "Masraf merkezi dağıtımı",
"module": "Finans & Faturalama",
"tier": "Plus"
},
{
"name": "Fatura-rezervasyon eşleştirme",
"module": "Finans & Faturalama",
"tier": "Pro"
},
{
"name": "Cari/ödeme durumu",
"module": "Finans & Faturalama",
"tier": "Pro"
},
{
"name": "Muhasebe entegrasyon aktarımı",
"module": "Finans & Faturalama",
"tier": "Pro"
},
{
"name": "Personel giriş-çıkış kaydı",
"module": "İnsan Kaynakları — Giriş/Çıkış (PDKS)",
"tier": "Plus"
},
{
"name": "Mesai özeti",
"module": "İnsan Kaynakları — Giriş/Çıkış (PDKS)",
"tier": "Plus"
},
{
"name": "Geç kalma/erken çıkış hesabı",
"module": "İnsan Kaynakları — Giriş/Çıkış (PDKS)",
"tier": "Plus"
},
{
"name": "Fazla mesai takibi",
"module": "İnsan Kaynakları — Giriş/Çıkış (PDKS)",
"tier": "Plus"
},
{
"name": "İzin/rapor/görevlendirme",
"module": "İnsan Kaynakları — Giriş/Çıkış (PDKS)",
"tier": "Plus"
},
{
"name": "Personel özlük kartı",
"module": "İnsan Kaynakları — Giriş/Çıkış (PDKS)",
"tier": "Plus"
},
{
"name": "Departman/ekip yapısı",
"module": "İnsan Kaynakları — Giriş/Çıkış (PDKS)",
"tier": "Plus"
},
{
"name": "Vardiya planlama",
"module": "İnsan Kaynakları — Giriş/Çıkış (PDKS)",
"tier": "Pro"
},
{
"name": "PDKS raporları & dışa aktarım",
"module": "İnsan Kaynakları — Giriş/Çıkış (PDKS)",
"tier": "Plus"
},
{
"name": "Kurumsal müşteri kayıtları",
"module": "CRM & Kurumsal Hesap",
"tier": "Plus"
},
{
"name": "Firma bazlı kullanıcı yönetimi",
"module": "CRM & Kurumsal Hesap",
"tier": "Plus"
},
{
"name": "Anlaşma/tarife bilgileri",
"module": "CRM & Kurumsal Hesap",
"tier": "Pro"
},
{
"name": "İletişim geçmişi",
"module": "CRM & Kurumsal Hesap",
"tier": "Plus"
},
{
"name": "Firma bazlı raporlama",
"module": "CRM & Kurumsal Hesap",
"tier": "Pro"
},
{
"name": "E-posta bildirimleri",
"module": "Bildirim & İletişim",
"tier": "Starter"
},
{
"name": "Uygulama içi bildirim",
"module": "Bildirim & İletişim",
"tier": "Starter"
},
{
"name": "SMS bildirim",
"module": "Bildirim & İletişim",
"tier": "Plus"
},
{
"name": "WhatsApp bildirim",
"module": "Bildirim & İletişim",
"tier": "Pro"
},
{
"name": "Hatırlatma/son tarih uyarısı",
"module": "Bildirim & İletişim",
"tier": "Plus"
},
{
"name": "Rol tabanlı yetkilendirme",
"module": "Kullanıcı, Rol & Güvenlik",
"tier": "Starter"
},
{
"name": "Güvenli oturum yönetimi",
"module": "Kullanıcı, Rol & Güvenlik",
"tier": "Starter"
},
{
"name": "İki adımlı doğrulama 2FA",
"module": "Kullanıcı, Rol & Güvenlik",
"tier": "Pro"
},
{
"name": "Veri erişim kısıtı",
"module": "Kullanıcı, Rol & Güvenlik",
"tier": "Plus"
},
{
"name": "İşlem denetim kayıtları",
"module": "Kullanıcı, Rol & Güvenlik",
"tier": "Plus"
},
{
"name": "Parola politikası",
"module": "Kullanıcı, Rol & Güvenlik",
"tier": "Plus"
},
{
"name": "Travel API entegrasyonu",
"module": "Entegrasyonlar",
"tier": "Plus"
},
{
"name": "E-posta sunucusu entegrasyonu",
"module": "Entegrasyonlar",
"tier": "Plus"
},
{
"name": "Takvim entegrasyonu",
"module": "Entegrasyonlar",
"tier": "Pro"
},
{
"name": "Muhasebe/ERP entegrasyonu",
"module": "Entegrasyonlar",
"tier": "Pro"
},
{
"name": "PDKS cihaz/İK entegrasyonu",
"module": "Entegrasyonlar",
"tier": "Pro"
},
{
"name": "API erişimi dış sistemler",
"module": "Entegrasyonlar",
"tier": "Pro"
},
{
"name": "Mobil uyumlu arayüz",
"module": "Arayüz, Mobil & Kullanılabilirlik",
"tier": "Starter"
},
{
"name": "Hızlı filtre & sıralama",
"module": "Arayüz, Mobil & Kullanılabilirlik",
"tier": "Starter"
},
{
"name": "Sürükle-bırak düzen",
"module": "Arayüz, Mobil & Kullanılabilirlik",
"tier": "Pro"
},
{
"name": "Klavye kısayolları",
"module": "Arayüz, Mobil & Kullanılabilirlik",
"tier": "Pro"
},
{
"name": "Erişilebilirlik uyumu",
"module": "Arayüz, Mobil & Kullanılabilirlik",
"tier": "Plus"
},
{
"name": "Yönetici ayar paneli",
"module": "Sistem Yönetimi & Altyapı",
"tier": "Plus"
},
{
"name": "Kullanıcı & yetki yönetimi",
"module": "Sistem Yönetimi & Altyapı",
"tier": "Starter"
},
{
"name": "Yedekleme & veri güvenliği",
"module": "Sistem Yönetimi & Altyapı",
"tier": "Pro"
},
{
"name": "Sistem sağlık izleme",
"module": "Sistem Yönetimi & Altyapı",
"tier": "Pro"
},
{
"name": "Veri dışa/içe aktarma",
"module": "Sistem Yönetimi & Altyapı",
"tier": "Plus"
},
{
"name": "Çok ortamlı yapı",
"module": "Sistem Yönetimi & Altyapı",
"tier": "Pro"
},
{
"name": "7/24 operasyon desteği",
"module": "Destek & SLA",
"tier": "Plus"
},
{
"name": "Öncelikli destek hattı",
"module": "Destek & SLA",
"tier": "Pro"
},
{
"name": "Bilgi bankası/yardım",
"module": "Destek & SLA",
"tier": "Starter"
},
{
"name": "Yerinde/uzaktan eğitim",
"module": "Destek & SLA",
"tier": "Pro"
},
{
"name": "Özel hesap yöneticisi",
"module": "Destek & SLA",
"tier": "Pro"
},
{
"name": "Görev oluşturma & atama",
"module": "Görev, Takvim & İş Planı",
"tier": "Starter"
},
{
"name": "Görev durum takibi",
"module": "Görev, Takvim & İş Planı",
"tier": "Starter"
},
{
"name": "Kişisel yapılacaklar listesi",
"module": "Görev, Takvim & İş Planı",
"tier": "Starter"
},
{
"name": "Operasyon takvimi",
"module": "Görev, Takvim & İş Planı",
"tier": "Plus"
},
{
"name": "Son tarih & hatırlatma",
"module": "Görev, Takvim & İş Planı",
"tier": "Plus"
},
{
"name": "Tekrarlayan görevler",
"module": "Görev, Takvim & İş Planı",
"tier": "Plus"
},
{
"name": "Takvim paylaşımı",
"module": "Görev, Takvim & İş Planı",
"tier": "Pro"
},
{
"name": "Merkezi belge deposu",
"module": "Belge & Sözleşme Yönetimi",
"tier": "Plus"
},
{
"name": "Sözleşme takibi",
"module": "Belge & Sözleşme Yönetimi",
"tier": "Plus"
},
{
"name": "Belge versiyonlama",
"module": "Belge & Sözleşme Yönetimi",
"tier": "Pro"
},
{
"name": "Sözleşme yenileme uyarısı",
"module": "Belge & Sözleşme Yönetimi",
"tier": "Pro"
},
{
"name": "Belge yetki/erişim kontrolü",
"module": "Belge & Sözleşme Yönetimi",
"tier": "Plus"
},
{
"name": "E-imza/onay akışı",
"module": "Belge & Sözleşme Yönetimi",
"tier": "Pro"
},
{
"name": "Kurumsal müşteri giriş portalı",
"module": "Müşteri Self-Servis Portalı",
"tier": "Plus"
},
{
"name": "Self-servis talep açma",
"module": "Müşteri Self-Servis Portalı",
"tier": "Plus"
},
{
"name": "Talep durumu izleme",
"module": "Müşteri Self-Servis Portalı",
"tier": "Plus"
},
{
"name": "Rezervasyon geçmişi görüntüleme",
"module": "Müşteri Self-Servis Portalı",
"tier": "Plus"
},
{
"name": "Müşteri raporu indirme",
"module": "Müşteri Self-Servis Portalı",
"tier": "Pro"
},
{
"name": "Onay bekleyen işlemler",
"module": "Müşteri Self-Servis Portalı",
"tier": "Pro"
},
{
"name": "Kural motoru koşul→aksiyon",
"module": "Otomasyon Kuralları (No-Code)",
"tier": "Pro"
},
{
"name": "Otomatik atama kuralları",
"module": "Otomasyon Kuralları (No-Code)",
"tier": "Plus"
},
{
"name": "Otomatik etiketleme",
"module": "Otomasyon Kuralları (No-Code)",
"tier": "Plus"
},
{
"name": "Otomatik bildirim tetikleyici",
"module": "Otomasyon Kuralları (No-Code)",
"tier": "Plus"
},
{
"name": "Otomatik eskalasyon kuralı",
"module": "Otomasyon Kuralları (No-Code)",
"tier": "Pro"
},
{
"name": "Zamanlanmış otomatik işler",
"module": "Otomasyon Kuralları (No-Code)",
"tier": "Plus"
},
{
"name": "Talep sonrası memnuniyet anketi",
"module": "Kalite, Memnuniyet & Geri Bildirim",
"tier": "Plus"
},
{
"name": "Puanlama & yorum toplama",
"module": "Kalite, Memnuniyet & Geri Bildirim",
"tier": "Plus"
},
{
"name": "Memnuniyet skoru raporu",
"module": "Kalite, Memnuniyet & Geri Bildirim",
"tier": "Pro"
},
{
"name": "Şikâyet/itiraz yönetimi",
"module": "Kalite, Memnuniyet & Geri Bildirim",
"tier": "Plus"
},
{
"name": "Hizmet kalite göstergesi",
"module": "Kalite, Memnuniyet & Geri Bildirim",
"tier": "Pro"
},
{
"name": "Seyahatçi konum/seyahat kaydı",
"module": "Seyahatçi Güvenliği & Duty of Care",
"tier": "Pro"
},
{
"name": "Acil durum bildirimi",
"module": "Seyahatçi Güvenliği & Duty of Care",
"tier": "Pro"
},
{
"name": "Seyahat risk uyarısı",
"module": "Seyahatçi Güvenliği & Duty of Care",
"tier": "Pro"
},
{
"name": "Yolcu iletişim listesi",
"module": "Seyahatçi Güvenliği & Duty of Care",
"tier": "Plus"
},
{
"name": "Karbon ayak izi takibi",
"module": "Sürdürülebilirlik & Maliyet Optimizasyonu",
"tier": "Pro"
},
{
"name": "Tasarruf fırsatı önerileri",
"module": "Sürdürülebilirlik & Maliyet Optimizasyonu",
"tier": "Pro"
},
{
"name": "Kullanılmayan bilet takibi",
"module": "Sürdürülebilirlik & Maliyet Optimizasyonu",
"tier": "Pro"
},
{
"name": "Harcama sızıntısı analizi",
"module": "Sürdürülebilirlik & Maliyet Optimizasyonu",
"tier": "Pro"
},
{
"name": "Aylık yönetici özet raporu",
"module": "Raporlama — Ek Rapor Tipleri",
"tier": "Plus"
},
{
"name": "Tedarikçi performans raporu",
"module": "Raporlama — Ek Rapor Tipleri",
"tier": "Pro"
},
{
"name": "Ödeme/tahsilat raporu",
"module": "Raporlama — Ek Rapor Tipleri",
"tier": "Pro"
},
{
"name": "Kullanıcı aktivite raporu",
"module": "Raporlama — Ek Rapor Tipleri",
"tier": "Pro"
},
{
"name": "İptal/değişiklik raporu",
"module": "Raporlama — Ek Rapor Tipleri",
"tier": "Pro"
},
{
"name": "Rota/güzergâh analizi",
"module": "Raporlama — Ek Rapor Tipleri",
"tier": "Pro"
},
{
"name": "Bütçe-gerçekleşen kıyas",
"module": "Raporlama — Ek Rapor Tipleri",
"tier": "Pro"
},
{
"name": "Özel filtreli rapor oluşturucu",
"module": "Raporlama — Ek Rapor Tipleri",
"tier": "Pro"
},
{
"name": "Fiyat geçmişi/izleme",
"module": "Travel API — Ek Sorgu & Ekranlar (KPLUS)",
"tier": "Pro"
},
{
"name": "Alternatif tarih önerisi",
"module": "Travel API — Ek Sorgu & Ekranlar (KPLUS)",
"tier": "Pro"
},
{
"name": "Kurumsal anlaşma fiyatı gösterimi",
"module": "Travel API — Ek Sorgu & Ekranlar (KPLUS)",
"tier": "Pro"
},
{
"name": "Uygunluk takvim görünümü",
"module": "Travel API — Ek Sorgu & Ekranlar (KPLUS)",
"tier": "Pro"
},
{
"name": "Sık kullanılan aramalar",
"module": "Travel API — Ek Sorgu & Ekranlar (KPLUS)",
"tier": "Plus"
},
{
"name": "Rezervasyon kural/koşul gösterimi",
"module": "Travel API — Ek Sorgu & Ekranlar (KPLUS)",
"tier": "Plus"
},
{
"name": "Bildirim tercih yönetimi",
"module": "Bildirim & İletişim — Ek",
"tier": "Plus"
},
{
"name": "Toplu duyuru gönderimi",
"module": "Bildirim & İletişim — Ek",
"tier": "Plus"
},
{
"name": "Şablonlu e-posta gönderimi",
"module": "Bildirim & İletişim — Ek",
"tier": "Plus"
},
{
"name": "Bildirim geçmişi",
"module": "Bildirim & İletişim — Ek",
"tier": "Plus"
},
{
"name": "Personel self-servis",
"module": "İK — Ek Özellikler",
"tier": "Plus"
},
{
"name": "Bordro için mesai aktarımı",
"module": "İK — Ek Özellikler",
"tier": "Pro"
},
{
"name": "Devamsızlık raporu",
"module": "İK — Ek Özellikler",
"tier": "Plus"
},
{
"name": "Resmi tatil/çalışma takvimi",
"module": "İK — Ek Özellikler",
"tier": "Plus"
},
{
"name": "Ziyaretçi giriş-çıkış kaydı",
"module": "İK — Ek Özellikler",
"tier": "Pro"
},
{
"name": "Şirket/şube bazlı ayarlar",
"module": "Yönetim & Ölçeklenme",
"tier": "Pro"
},
{
"name": "Özel alan custom field tanımı",
"module": "Yönetim & Ölçeklenme",
"tier": "Pro"
},
{
"name": "İş akışı tasarımcısı",
"module": "Yönetim & Ölçeklenme",
"tier": "Pro"
},
{
"name": "Kota/kullanım limiti izleme",
"module": "Yönetim & Ölçeklenme",
"tier": "Pro"
},
{
"name": "Kullanım istatistikleri",
"module": "Yönetim & Ölçeklenme",
"tier": "Plus"
},
{
"name": "Çoklu para birimi desteği",
"module": "Finans & Faturalama",
"tier": "Starter"
},
{
"name": "Yolcu takibi desteği",
"module": "Seyahat Politikası & Onay",
"tier": "Starter"
}
];
